import styled from "styled-components";

export const Container = styled.button`
  background: #0000ff;
  padding: 1.25rem;
  width: 100%;
  color: #fff;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  margin: 1.875rem 0;
  transition: filter 0.3s ease-in-out;

  &:hover,
  &:focus {
    filter: brightness(0.8);
  }

  @media (min-width: 540px) {
    width: 24rem;
  }
`;
